import { render, staticRenderFns } from "./PaymentViewer.vue?vue&type=template&id=60a8d28c"
import script from "./PaymentViewer.vue?vue&type=script&lang=js"
export * from "./PaymentViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports